import { useState, useRef, useEffect, useCallback } from 'react';
import { Tooltip } from 'react-tooltip';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

import * as validate from '../../utils/phoneValidation.js';
import useApi from '../../utils/useApi';
import 'react-tooltip/dist/react-tooltip.css';
import '../../css/common-components.css';
import '../../css/common-styles.css';
import noDocumentImage from '../../images/no-document-copy.png';
import loadIcon from '../../images/loader-transparent.svg';
import excelIcon from '../../images/excel_icon.svg';
import Toaster from '../Toaster/Toaster.jsx';
import Error from '../Error/Error.jsx';
import errorContent from '../../utils/ErrorMessages';
import InternationalPhoneInput from '../InternationalPhoneInput/InternationalPhoneInput.jsx';
import AddCC from '../CC/AddCC.jsx';
import FileUploadManager from '../FileUploadManager/FileUploadManager.jsx';
import { ALLOWED_COUNTRIES, DEFAULT_COUNTRY } from '../../utils/flagsConfig.js';
import DocumentSettingsSection from '../DocumentSettings/DocumentSettings.jsx';
import MissingLocaleMessageDialogBox from '../MissingLocaleMessageDialogBox/MissingLocaleMessageDialogBox.jsx';

import styles from './DocumentSend.module.css';

const DocumentSend = () => {

  // Store URL parameters in state
  const [recordId, setRecordId] = useState('');
  const [objectType, setObjectType] = useState('');
  const [popup, setPopup] = useState('');
  const [brandslist, setBrandsList] = useState([]);
  const [isBrandsListEmpty, setIsBrandsListEmpty] = useState(false);

  const MAX_CC_RECIPIENTS = 20;
  // Parse URL parameters on component mount
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      setRecordId(url.searchParams.get('recordId') || '');
      setObjectType(url.searchParams.get('objectType') || '');
      setPopup(url.searchParams.get('popup') || '');
    } catch (error) {
      console.error("Error parsing URL parameters:", error);
    }
  }, []);

  const api = useApi();

  // Toaster functions
  const showToaster = (message, type = 'error') => {
    setToasterMessage({ show: true, message, type });
  };

  const hideToaster = () => {
    setToasterMessage({ show: false, message: '', type: 'error' });
  };

  const languageNames = {
    'EN': 'English',
    'ES': 'Spanish',
    'DE': 'German',
    'FR': 'French',
    'RO': 'Romanian',
    'NO': 'Norwegian',
    'BG': 'Bulgarian',
    'IT': 'Italian',
    'DA': 'Danish',
    'PL': 'Polish',
    'PT': 'Portuguese',
    'CS': 'Czech',
    'NL': 'Dutch',
    'RU': 'Russian',
    'SV': 'Swedish',
    'ZH_CN':'SimplifiedChinese',
    'ZH_TW':'TraditionalChinese',
    'JA':'Japanese',
    'TH':'Thai',
    'KO':'Korean'
  };
  const recipientRoles = [
    { id: 'signer', name: 'Signer', icon: <div className="signer-icon"></div> },
    { id: 'reviewer', name: 'Reviewer', icon: <div className="reviewer-icon"></div>}
  ];

  // Function to generate random bright colors

  const fixedColorSequence = [
  'rgb(253, 247, 219)',
  'rgb(214, 255, 221)',
  'rgb(217, 244, 254)',
  'rgb(244, 221, 255)',
  'rgb(221, 228, 255)',
  'rgb(219, 253, 247)'
];

    const [recipientColors, setRecipientColors] = useState(() => ({ 1: fixedColorSequence[0] }));
  
  const [recipients, setRecipients] = useState([
    { id: 1, name: '', email: '', iso:'us', phone:'', fullPhone:'', countryCode:'', deliveryOption: 'Email', language: 'EN', role: 'signer', order: 1, showDeliveryOptions: false, showSettingsOptions: false, showAuthenticationSetting: false, privateMessageSetting: false, allowFieldConfigurationSetting: false, authType: 'accessCode', accessCode: '', privateMessage: '' }
  ]);
  
  const [signingOrder, setSigningOrder] = useState(false);
  
  // Document settings - now managed by DocumentSettingsSection component
  const [documentSettings, setDocumentSettings] = useState({
    brand: null,
    tags: [],
    enablePrintAndSign: false,
    enableReassign: true,
    documentDownloadOption: 'combined',
    expiryValue: '60',
    enableExpiryAlert: false,
    enableAutoReminder: false,
    reminderDays: '2',
    reminderCount: '3'
  });
  const [documents, setDocuments] = useState({ title: '', message: '' });

  const [documentInfo, setDocumentInfo] = useState({});
  const [activeLocale, setActiveLocale] = useState('EN');
  const [hasAutoFilledTitle, setHasAutoFilledTitle] = useState(false);
  const lastWrittenDocRef = useRef({ title: '', message: '' });
  const skipDocMirrorRef = useRef(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState({ type: null, id: null });
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [tempOrderValue, setTempOrderValue] = useState('');
  const [replacingFileId, setReplacingFileId] = useState(null);
  const [replacingFileIndex, setReplacingFileIndex] = useState(null);
  const [replacingUploadingId, setReplacingUploadingId] = useState(null);
  const [errors, setErrors] = useState({
    files: [],
    title: '',
    recipients: [],
    phone: '',
    cc: '',
    signerError: '',
    progressError: '',
    accessCode: '',
    reminder: ''
  });
  const [ccRecipients, setCcRecipients] = useState('');
  const [ccEmailTags, setCcEmailTags] = useState([]);
  const [filteredContactSuggestions, setFilteredContactSuggestions] = useState([]);
  const [focusedInputId, setFocusedInputId] = useState(null);
  const [ccInputValue, setCcInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [addMeVisible, setAddMeVisible] = useState(true);
  const [currentUserEmail, setCurrentUserEmail] = useState(null);
  const [fetchedCurrentUser, setFetchedCurrentUser] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [iframeSrc, setIframeSrc] = useState('');
  const [iframeLoading, setIframeLoading] = useState(false);
  const [iframeError, setIframeError] = useState(false);
  const [toasterMessage, setToasterMessage] = useState({ show: false, message: '', type: 'error' });
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [errorPageConfig, setErrorPageConfig] = useState({});
  const [hoveredRecipientId, setHoveredRecipientId] = useState(null);
  const hasIncompleteUploads = [...uploadedFiles, ...uploadingFiles].some(f => f.progress < 100);
  const [showLocaleMessageDialog, setShowLocaleMessageDialog] = useState(false);
  const [missingMessageLocales, setMissingMessageLocales] = useState([]);

  const fileInputRef = useRef(null);
  const uploadIntervalsRef = useRef({});
  const dropdownRefs = useRef({});
  const orderInputRef = useRef(null);
  const iframeRef = useRef(null);
  const editingTagRef = useRef(null);
  const recipientRowRefs = useRef({});
  const dragGhostRef = useRef(null);

  // Drag and drop state for signing order
  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const handleCcChange = useCallback((emails) => {
    setCcEmailTags(emails);
  }, []);

  const getUniqueRecipientLocales = useCallback(() => {
    const seen = [];
    recipients.forEach((r) => {
      const locale = r.language || r.locale;
      if (locale && !seen.includes(locale)) seen.push(locale);
    });
    return seen;
  }, [recipients]);

  // Returns the list of unique locales whose message is currently empty.
  const getLocalesWithMissingMessage = useCallback(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length < 2) return [];
    return uniqueLocales.filter((loc) => !((documentInfo[loc]?.message || '').trim()));
  }, [getUniqueRecipientLocales, documentInfo]);

  useEffect(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length === 0) return;

    setDocumentInfo((prev) => {
      const seedTitle = (prev[uniqueLocales[0]] && prev[uniqueLocales[0]].title) || documents.title || '';
      const next = {};
      uniqueLocales.forEach((loc) => {
        if (prev[loc]) {
          next[loc] = prev[loc];
        } else {
          next[loc] = { title: seedTitle, message: '' };
        }
      });
      return next;
    });

    setActiveLocale((prev) => (uniqueLocales.includes(prev) ? prev : uniqueLocales[0]));
  }, [getUniqueRecipientLocales, documents.title, documents.message]);

  useEffect(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length === 0) return;
    const active = documentInfo[activeLocale] || { title: '', message: '' };
    if (skipDocMirrorRef.current) {
      skipDocMirrorRef.current = false;
      lastWrittenDocRef.current = { title: active.title || '', message: active.message || '' };
      return;
    }
    const nextTitle = active.title || '';
    const nextMessage = active.message || '';
    if (lastWrittenDocRef.current.title !== nextTitle || lastWrittenDocRef.current.message !== nextMessage) {
      lastWrittenDocRef.current = { title: nextTitle, message: nextMessage };
      setDocuments({ title: nextTitle, message: nextMessage });
    }
    if (!hasIncompleteUploads && uploadedFiles.length === 0 && hasAutoFilledTitle) {
      setHasAutoFilledTitle(false);
    }
  }, [documentInfo, activeLocale, getUniqueRecipientLocales]);

  useEffect(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length === 0) return;
    const last = lastWrittenDocRef.current;
    if (documents.title === last.title && documents.message === last.message) {
      return;
    }
    lastWrittenDocRef.current = { title: documents.title, message: documents.message };
    skipDocMirrorRef.current = true;
    setDocumentInfo((prev) => {
      const allTitlesEmpty = uniqueLocales.every((locale) => !(prev[locale]?.title || '').trim());
      const allTitlesMatchPrevious = uniqueLocales.every(
        locale => (prev[locale]?.title || '') === last.title
      );
      if ((allTitlesEmpty || allTitlesMatchPrevious) && documents.title.trim()) {
        const next = { ...prev };
        uniqueLocales.forEach((locale) => {
          next[locale] = {
            ...(prev[locale] || { title: '', message: '' }),
            title: documents.title
          };
        });
        return next;
      }

      const targetLocale = uniqueLocales.length === 1 ? uniqueLocales[0] : activeLocale;
      const current = prev[targetLocale] || { title: '', message: '' };
      if (current.title === documents.title && current.message === documents.message) return prev;
      return {
        ...prev,
        [targetLocale]: { title: documents.title, message: documents.message }
      };
    });
  }, [documents.title, documents.message]);

  useEffect(() => {
    if (uploadedFiles.length !== 0 || uploadingFiles.length !== 0) return;
    setDocumentInfo(prev => {
      const locales = getUniqueRecipientLocales();
      if (locales.length === 0) return prev;
      const next = { ...prev };
      locales.forEach(locale => {
        next[locale] = { ...(next[locale] || { title: '', message: '' }), title: '' };
      });
      return next;
    });
    setDocuments(prev => (prev.title ? { ...prev, title: '' } : prev));
    lastWrittenDocRef.current = { title: '', message: documents.message };
  }, [uploadedFiles.length, uploadingFiles.length, getUniqueRecipientLocales]);

  const updateDocumentInfoField = (locale, field, value, currentInfo) => {
    const title = field === 'title' ? value : currentInfo.title || '';
    const message = field === 'message' ? value : currentInfo.message || '';

    skipDocMirrorRef.current = false;
    if (locale) {
      setDocumentInfo(prev => ({
        ...prev,
        [locale]: {
          ...(prev[locale] || { title: '', message: '' }),
          [field]: value
        }
      }));
    }
    skipDocMirrorRef.current = true;
    setDocuments(prev => ({ ...prev, [field]: value }));
    lastWrittenDocRef.current = { title, message };

    if (field === 'title' && errors.title) {
      setErrors(prev => ({ ...prev, title: '' }));
    }
  };

  const reorderRecipientsByDrag = useCallback((fromId, toId) => {
    if (fromId === null || toId === null || fromId === toId) return;
    // Work on a sorted copy by current order
    const sorted = [...recipients].sort((a, b) => a.order - b.order);
    const fromIndex = sorted.findIndex(r => r.id === fromId);
    const toIndex = sorted.findIndex(r => r.id === toId);
    if (fromIndex === -1 || toIndex === -1) return;
    const [moved] = sorted.splice(fromIndex, 1);
    sorted.splice(toIndex, 0, moved);
    // Reassign consecutive order values starting from 1
    const reassigned = sorted.map((r, idx) => ({ ...r, order: idx + 1 }));
    // Merge back to original ids
    const updated = recipients.map(r => {
      const updatedItem = reassigned.find(x => x.id === r.id);
      return updatedItem ? updatedItem : r;
    });
    setRecipients(updated);
  }, [recipients]);
  
  const onDragStartHandle = (e, id) => {
    if (!signingOrder) return;
    setDraggingId(id);
    try {
      e.dataTransfer.effectAllowed = 'move';
      const rowEl = recipientRowRefs.current[id];
      if (rowEl && e.dataTransfer.setDragImage) {
        // Create a lightweight ghost to avoid browser selection blue line
        const ghost = rowEl.cloneNode(true);
        // Apply shared styles via CSS class instead of inline styles
        ghost.classList.add('drag-ghost');
        // Preserve dynamic sizing via inline width to match the dragged element
        ghost.style.width = rowEl.offsetWidth + 'px';
        document.body.appendChild(ghost);
        dragGhostRef.current = ghost;
        const rect = rowEl.getBoundingClientRect();
        // Center the drag image to avoid the preview jumping to the left
        e.dataTransfer.setDragImage(ghost, rect.width/80, rect.height/80);
      }
    }
    catch {
      // no-op: optional drag image may not be supported
    }
  };
  const onDragOverRow = (e, targetId) => {
    if (!signingOrder) return;
    e.preventDefault();
    try { e.dataTransfer.dropEffect = 'move'; }
    catch {
      // no-op: some browsers may not support setting dropEffect
    }
    // Live-reorder while dragging: when hovering a new target row, move the dragged item
    setDragOverId(prev => {
      if (draggingId !== null && targetId && targetId !== draggingId && targetId !== prev) {
        reorderRecipientsByDrag(draggingId, targetId);
      }
      return targetId ?? null;
    });
  };
  
  const onDropRow = (e, targetId) => {
    if (!signingOrder) return;
    e.preventDefault();
    if (draggingId !== null) {
      reorderRecipientsByDrag(draggingId, targetId);
    }
    setDraggingId(null);
    
    // Clean up drag ghost if present
    if (dragGhostRef.current && dragGhostRef.current.parentNode) {
      try { dragGhostRef.current.parentNode.removeChild(dragGhostRef.current); }
      catch {
        // no-op: node may already be removed
      }
      dragGhostRef.current = null;
    }
  };
  const onDragEndHandle = () => {
    // Ensure cleanup when drag is cancelled or ends outside a valid drop zone
    setDraggingId(null);
    setDragOverId(null);
    if (dragGhostRef.current && dragGhostRef.current.parentNode) {
      try { dragGhostRef.current.parentNode.removeChild(dragGhostRef.current); }
      catch {
        // no-op: node may already be removed
      }
      dragGhostRef.current = null;
    }
  };

  // Handle iframe messages
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (data.action === "DONE") {
          // Forward to parent if needed
          window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
        }
      } catch (e) {
        console.error("Invalid message from iframe:", e);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

const finishEditingOrder = useCallback(() => {
  if (editingOrderId === null) return;
  const newOrder = parseInt(tempOrderValue) || 1;
  
  // Get the current order of the recipient being edited
  const currentRecipient = recipients.find(r => r.id === editingOrderId);
  const currentOrder = currentRecipient ? currentRecipient.order : 1;
  
  // If the order hasn't changed, just exit
  if (newOrder === currentOrder) {
    setEditingOrderId(null);
    setTempOrderValue('');
    return;
  }
  
  // Find the maximum consecutive position in the current sequence
  const allOrders = recipients.map(r => r.order).sort((a, b) => a - b);
  
  // Find the highest consecutive number starting from 1
  let maxConsecutive = 0;
  for (let i = 1; i <= recipients.length; i++) {
    if (allOrders.includes(i)) {
      maxConsecutive = i;
    } else {
      break;
    }
  }
  
  // The next available consecutive position
  const nextConsecutive = maxConsecutive + 1;
  
  // Determine the final order for the edited recipient
  let finalOrder;
  if (newOrder <= nextConsecutive) {
    // Allow the requested order if it's within the consecutive range
    finalOrder = newOrder;
  } else {
    // Clamp to the next consecutive position if beyond the range
    finalOrder = nextConsecutive;
  }
  
  // Step 1: Set the edited recipient to their new order
  let updatedRecipients = recipients.map(recipient => {
    if (recipient.id === editingOrderId) {
      return { ...recipient, order: finalOrder };
    }
    return recipient;
  });
  
  // Step 2: Compress the sequence to eliminate gaps
  // Get all unique orders and sort them
  const uniqueOrders = [...new Set(updatedRecipients.map(r => r.order))].sort((a, b) => a - b);
  
  // Create a mapping from old orders to new consecutive orders
  const orderMapping = {};
  uniqueOrders.forEach((order, index) => {
    orderMapping[order] = index + 1;
  });
  
  // Apply the mapping to compress the sequence
  const compressedRecipients = updatedRecipients.map(recipient => ({
    ...recipient,
    order: orderMapping[recipient.order]
  }));
  
  // Sort recipients by order, with edited recipient taking priority in case of ties
  const sortedRecipients = compressedRecipients.sort((a, b) => {
    if (a.order === b.order) {
      // If orders are the same, prioritize the edited recipient
      if (a.id === editingOrderId) return -1;
      if (b.id === editingOrderId) return 1;
      return 0;
    }
    return a.order - b.order;
  });
  
  setRecipients(sortedRecipients);
  setEditingOrderId(null);
  setTempOrderValue('');
}, [editingOrderId, tempOrderValue, recipients]);

// Add this to the DocumentSend.jsx file - state and function declarations
const [contactSuggestions, setContactSuggestions] = useState([]);

const loadContactData = useCallback(async () => {
  try {
    let allContacts = [];
    
    // For contact object type, we need to get both primary and associated contacts
    if (objectType.toLowerCase() === 'contact') {
      try {
        // First, get the primary contact
        const primaryContactResponse = await api.get(`/hubspot/get-contacts`,
          {
            params: {
              contactId: recordId
            }
          });
        if (primaryContactResponse.status !== 200) {
          const errorText = await primaryContactResponse.data;
          let errorMessage = 'Failed to load primary contact information.';
          
          try {
            let errorData;
            if (typeof errorText === 'string'){
              errorData = JSON.parse(errorText);
            }
            else{
              errorData = errorText;
            }
            
            if (errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (parseError) {
            if (errorText) {
              errorMessage = errorText.title;
            }
          }
          
          showToaster(errorMessage, 'error');
          return;
        }
        
            const primaryContact = await primaryContactResponse.data;
        if (primaryContact && primaryContact.name && primaryContact.email) {
          primaryContact.phoneNumberWithCountryCode = validate.parsePhoneNumberWithCountryCode(primaryContact.phoneNumberWithCountryCode)
          allContacts.push(primaryContact);
        }
        
        // Second, get associated contacts
        try {
          const associatedContactsResponse = await api.get(`/hubspot/get-associated-contacts`,
            {
              params: {
                objectId: recordId,
                objectType
              }
            });
          console.log(`Fetching the secondary contacts of contacts object`)
          if (associatedContactsResponse.status === 200) {
                const associatedContacts = await associatedContactsResponse.data;
            if (Array.isArray(associatedContacts)) {
              const validAssociatedContacts = associatedContacts.filter(contact => 
                contact.name && 
                contact.email && 
                // Avoid duplicating the primary contact if it appears in associated contacts
                !allContacts.some(existing => existing.email.toLowerCase() === contact.email.toLowerCase())
              );
              validAssociatedContacts.forEach((contact)=>{
                contact.phoneNumberWithCountryCode = validate.parsePhoneNumberWithCountryCode(contact.phoneNumberWithCountryCode);
              });
              allContacts.push(...validAssociatedContacts);
            }
          }
        } catch (associatedError) {
          console.error('Error loading associated contacts for contact object:', associatedError);
          // Don't show error for associated contacts failure if we have primary contact
        }
        
      } catch (error) {
        console.error('Error loading contact data for contact object:', error);
        showToaster('Failed to load contact information. Please try again.', 'error');
        return;
      }
    } else if (objectType.toLowerCase() === 'deal' || objectType.toLowerCase() === 'company') {
      // For deals and companies, get associated contacts
      try {
        const response = await api.get(`/hubspot/get-associated-contacts`, {
          params: {
            objectId: recordId,
            objectType
          }
        });
        
        if (response.status !== 200) {
          const errorText = await response.data;
          let errorMessage = 'Failed to load associated contacts.';
          
          try {
            const errorData = JSON.parse(errorText);
            if (errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (parseError) {
            if (errorText) {
              errorMessage = errorText;
            }
          }
          
          showToaster(errorMessage, 'error');
          return;
        }
        
            const data = await response.data;
        if (Array.isArray(data)) {
          const validContacts = data.filter(contact => contact.name && contact.email);
          validContacts.forEach((contact)=>{
            contact.phoneNumberWithCountryCode = validate.parsePhoneNumberWithCountryCode(contact.phoneNumberWithCountryCode);
          });
          allContacts.push(...validContacts);
        }
        
      } catch (error) {
        console.error('Error loading associated contacts:', error);
        showToaster('Failed to load contact information. Please try again.', 'error');
        return;
      }
      }
    
    // Set all collected contacts (even if empty array - this is normal for some records)
    setContactSuggestions(allContacts);
    setFilteredContactSuggestions(allContacts);
    
  } catch (error) {
    console.error('Error loading contact data:', error);
    showToaster('Unable to load contact information. Please check your connection.', 'error');
  }
}, [recordId, objectType]);

// Effect to load contact data on component mount
useEffect(() => {
  loadContactData();
}, [loadContactData]);

// Function to filter contact suggestions based on search text
const filterContactSuggestions = useCallback((searchText) => {
  if (!searchText || searchText.trim() === '') {
    setFilteredContactSuggestions(contactSuggestions);
    return;
  }
  
  const filtered = contactSuggestions.filter(contact => {
    const searchLower = searchText.toLowerCase();
    return contact.name.toLowerCase().includes(searchLower) || 
           contact.email.toLowerCase().includes(searchLower) || 
           contact.phoneNumberWithCountryCode || 
           contact.phoneNumber;
  });
  
  setFilteredContactSuggestions(filtered);
}, [contactSuggestions]);

// Function to apply suggestion data to recipient
const applySuggestion = (recipientId, selectedContact) => {
  if (!selectedContact) return;
  
  const index = recipients.findIndex(r => r.id === recipientId);
  if (index === -1) return;
  
  // Get the recipient to check delivery option and SMSOTP status
  const recipient = recipients[index];
  var iso = "us";
  var countryCode = `+1`;
  var nationalNumber = "";
  var fullPhone = "";

  const parsed = parsePhoneNumberFromString(selectedContact.phoneNumberWithCountryCode);
  const isCountryAllowed = ALLOWED_COUNTRIES.includes(parsed?.country?.toLowerCase())

  if (parsed && isCountryAllowed) {
    iso = parsed.country?.toLowerCase();
    countryCode = `+${parsed.countryCallingCode}`;
    nationalNumber = parsed.nationalNumber;
    fullPhone = parsed.number;
  }

  // Update name and email first
  const updatedRecipients = recipients.map(recipient => {
    if (recipient.id === recipientId) {
      const canSendEmail = recipient.deliveryOption !== 'SMS';
      const canSendSMS = recipient.deliveryOption !== 'Email';
      const overridePhoneNumer = recipient.authType === 'SMS' && !recipient.phone;

      return {
        ...recipient,
        name: selectedContact.name,
        email: canSendEmail ? selectedContact.email : '',
        fullPhone: canSendSMS ? fullPhone : overridePhoneNumer ? fullPhone : recipient.fullPhone,
        phone: canSendSMS ? nationalNumber : overridePhoneNumer ? nationalNumber : recipient.phone,
        countryCode: canSendSMS ? countryCode : overridePhoneNumer ? countryCode : recipient.countryCode,
        iso: canSendSMS ? parsed?.country?.toLowerCase() : overridePhoneNumer ? parsed?.country?.toLowerCase() : recipient.iso
      };
    }
    return recipient;
  });
  
  setRecipients(updatedRecipients);
  
  // If the selected contact's email exists in CC, flag an inline error instead of removing CC
  if (recipient.deliveryOption !== 'SMS' && selectedContact.email && isValidEmail(selectedContact.email)) {
    const emailToCheck = selectedContact.email.toLowerCase();
    const emailExistsInCC = ccEmailTags.some(ccEmail => ccEmail.toLowerCase() === emailToCheck);

    if (emailExistsInCC) {
      setErrors(prev => {
        const newRecipientErrors = [...prev.recipients];
        if (!newRecipientErrors[index]) {
          newRecipientErrors[index] = { name: '', email: '' };
        }
        newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Recipient already exists in CC' };
        return { ...prev, recipients: newRecipientErrors };
      });
    }
  }
  
  // Check for duplicate emails and update all error messages
  setErrors(prev => {
    const newRecipientErrors = [...prev.recipients];
    
    // First, clear duplicate errors from all recipients
    for (let i = 0; i < newRecipientErrors.length; i++) {
      if (newRecipientErrors[i] && newRecipientErrors[i].email === 'Email already exists') {
        newRecipientErrors[i] = { ...newRecipientErrors[i], email: '' };
      }
    }
    
    newRecipientErrors.forEach((error, idx) => {
      if (error && error.name === 'Name is required') {
        newRecipientErrors[idx] = { ...error, name: '' };
      }
      if (error && error.email === 'Email is required') {
        newRecipientErrors[idx] = { ...error, email: '' };
      }
      if (error && error.phone === 'Phone number is required') {
        newRecipientErrors[idx] = { ...error, phone: '' };
      }
    });
    // Get all emails for checking duplicates
    const emailsMap = new Map();
    const duplicateEmails = new Set();
    
    // First pass: find duplicate emails
    updatedRecipients.forEach((recipient, idx) => {
      const email = recipient.email.trim().toLowerCase();
      if (email && isValidEmail(email)) {
        if (emailsMap.has(email)) {
          duplicateEmails.add(email);
        } else {
          emailsMap.set(email, idx);
        }
      }
    });
    
    // Second pass: mark all duplicates with errors
    updatedRecipients.forEach((recipient, idx) => {
      const email = recipient.email.trim().toLowerCase();
      const fullPhone = recipient.fullPhone.trim();
      const phone = recipient.phone.trim();
      if (!signingOrder && email !== '' && isValidEmail(email) && duplicateEmails.has(email)) {
        // Mark ALL occurrences of this email as duplicate
        if (!newRecipientErrors[idx]) {
          newRecipientErrors[idx] = { name: '', email: '', phone: '' };
        }
        newRecipientErrors[idx] = { ...newRecipientErrors[idx], email: 'Email already exists' };
      }
      if (!signingOrder && recipient.deliveryOption !== 'Email' && phone !== '' && validate.isValidPhoneNumber(fullPhone)) {
        const normalizedPhone = fullPhone.trim();

        const isDuplicate = updatedRecipients.some((r, i) =>
          i !== idx &&
          r.deliveryOption !== 'Email' &&
          r.fullPhone &&
          r.fullPhone.trim() === normalizedPhone
        );
      
        if (isDuplicate) {
          if (!newRecipientErrors[idx]) {
            newRecipientErrors[idx] = { name: '', email: '', phone: '' };
          }
          newRecipientErrors[idx] = {
            ...newRecipientErrors[idx],
            phone: 'Recipient already exists'
          };
        } else {
          if (newRecipientErrors[idx]) {
            newRecipientErrors[idx].phone = '';
          }
        }
      }
    });
    
    return {
      ...prev,
      recipients: newRecipientErrors
    };
  });
  
  // Clear highlight and the focused input after selection
  setHoveredRecipientId(null);
  setFocusedInputId(null);
};

// Function to update ccRecipients based on tags
const updateCcRecipientsFromTags = (tags) => {
  setCcRecipients(tags.join(', '));
};

  // Toggle dropdown for recipient role and language dropdowns
  const toggleDropdown = (type, id) => {
    if (activeDropdown.type === type && activeDropdown.id === id) {
      setActiveDropdown({ type: null, id: null });
    } else {
      setActiveDropdown({ type, id });
    }
  };

const MAX_RECIPIENTS = 50;

const addRecipient = () => {
  // Guard : stop when max reached
  if (recipients.length >= MAX_RECIPIENTS) {
    return;
  }

  const newId = recipients.length > 0 ? Math.max(...recipients.map(r => r.id)) + 1 : 1;

  // Find the next available consecutive order
  const existingOrders = recipients.map(r => r.order).sort((a, b) => a - b);
  let newOrder = 1;
  while (existingOrders.includes(newOrder)) {
    newOrder++;
  }

  // Assign a unique color from the fixed sequence
  const usedColors = Object.values(recipientColors);

  const availableColor = fixedColorSequence.find(color => !usedColors.includes(color)) 
    || fixedColorSequence[recipients.length % fixedColorSequence.length];

  // Add the new recipient
  setRecipients([...recipients, {
    id: newId,
    name: '',
    email: '',
    phone: '',
    fullPhone: '',
    countryCode: '',
    deliveryOption: 'Email',
    language: 'EN',
    role: 'signer',
    order: newOrder,
    showDeliveryOptions: false
  }]);

  // Assign color
  setRecipientColors(prev => ({ ...prev, [newId]: availableColor }));

  // Add empty error field
  setErrors(prev => ({
    ...prev,
    recipients: [...(prev.recipients || []), { name: '', email: '' }]
  }));
};

// Fetch current BoldSign user once to determine Add Me visibility
const [cachedCurrentUser, setCachedCurrentUser] = useState(null);

useEffect(() => {
  let mounted = true;
  const fetchCurrent = async () => {
    if (fetchedCurrentUser) return;
    setFetchedCurrentUser(true);
    try {
      const resp = await api.get('/boldsign/get-current-user');
      if (resp && resp.status === 200) {
        const u = await resp.data;
        if (u && u.email) {
          setCachedCurrentUser(u); // Cache the user data
          const email = (u.email || '').trim().toLowerCase();
          if (mounted) setCurrentUserEmail(email);
          // If recipients already contain this email, hide Add Me
          const exists = recipients.some(r => (r.email || '').trim().toLowerCase() === email);
          if (mounted && exists) setAddMeVisible(false);
        }
      }
    } catch (e) {
      // Ignore errors for visibility; Add Me remains visible by default
      // console.debug('Could not fetch current BoldSign user for visibility', e);
    }
  };

  fetchCurrent();
  return () => { mounted = false; };
}, []);

// Recompute Add Me visibility when recipients or currentUserEmail change
useEffect(() => {
  if (!currentUserEmail) return;
  const exists = recipients.some(r => (r.email || '').trim().toLowerCase() === currentUserEmail);
  setAddMeVisible(!exists);
}, [recipients, currentUserEmail]);

  const recomputeDuplicateErrors = (recipientsList, signingOrderFlag, prevErrors) => {
    const newErrors = [...(prevErrors?.recipients || [])];

    // Clear existing duplicate errors
    for (let i = 0; i < newErrors.length; i++) {
      if (!newErrors[i]) continue;
      if (newErrors[i].email === 'Email already exists') {
        newErrors[i].email = '';
      }
      if (newErrors[i].phone === 'Recipient already exists') {
        newErrors[i].phone = '';
      }
    }

    if (signingOrderFlag) {
      return newErrors; // no duplicate validation when signing order enabled
    }

    const emailMap = new Map();
    const duplicateEmails = new Set();

    recipientsList.forEach((r, i) => {
      const email = (r.email || '').trim().toLowerCase();
      if (email && isValidEmail(email)) {
        if (emailMap.has(email)) duplicateEmails.add(email);
        else emailMap.set(email, i);
      }
    });

    recipientsList.forEach((r, i) => {
      const email = (r.email || '').trim().toLowerCase();
      if (email && duplicateEmails.has(email)) {
        if (!newErrors[i]) newErrors[i] = {};
        newErrors[i].email = 'Email already exists';
      }
    });

    return newErrors;
  };

// Handle Add Me action: use cached user data to populate a recipient row
const handleAddMeClick = () => {
  // Use cached user data from initial fetch - no additional API call needed
  const user = cachedCurrentUser;
  
  if (!user || !user.email) {
    showToaster('BoldSign profile does not contain an email address.', 'error');
    return;
  }

  try {
    const userEmail = (user.email || '').trim().toLowerCase();
    const userName = (user.fullName || '').trim();

    // Validate email format before adding
    if (!isValidEmail(userEmail)) {
      showToaster('BoldSign returned an invalid email address.', 'error');
      return;
    }

    // If any recipient already has this email (case-insensitive), hide Add Me and do nothing
    const exists = recipients.some(r => (r.email || '').trim().toLowerCase() === userEmail);
    if (exists && !signingOrder) {
      setAddMeVisible(false);
      return;
    }

    // Find first empty recipient row (both name and email empty)
    const emptyIndex = recipients.findIndex(r => !(r.email && r.email.trim()) && !(r.name && r.name.trim()) && r.deliveryOption != 'SMS');
    if (emptyIndex !== -1) {
      const updated = recipients.map((r, idx) => idx === emptyIndex ? { ...r, name: userName, email: userEmail } : r);
      setRecipients(updated);
      setRecipientTouched(prev => ({
        ...prev,
        [updated[emptyIndex].id]: {
          ...(prev[updated[emptyIndex].id] || {}),
          name: true,
          email: true
        }
      }));
      setErrors(prev => {
        const newRecipientErrors = [...prev.recipients];
        if (newRecipientErrors[emptyIndex]) {
          newRecipientErrors[emptyIndex] = {
            ...newRecipientErrors[emptyIndex],
            name: '',
            email: ''
          };
        }
        return { ...prev, recipients: newRecipientErrors };
      });
    } else {
      // Append a new recipient without mutating other rows
      addRecipient();
      // After adding, set the last recipient to the user values
      setTimeout(() => {
        setRecipients(prev => {
          if (!prev || prev.length === 0) return prev;
          const lastIdx = prev.length - 1;
          const lastRecipientId = prev[lastIdx]?.id;
          if (lastRecipientId !== undefined) {
            setRecipientTouched(touchedPrev => ({
              ...touchedPrev,
              [lastRecipientId]: {
                ...(touchedPrev[lastRecipientId] || {}),
                name: true,
                email: true
              }
            }));
          }
          const updated = prev.map((r, idx) => idx === lastIdx ? { ...r, name: userName, email: userEmail } : r);
          setErrors(prevErrors => {
            const newRecipientErrors = [...prevErrors.recipients];
            if (newRecipientErrors[lastIdx]) {
              newRecipientErrors[lastIdx] = {
                ...newRecipientErrors[lastIdx],
                name: '',
                email: ''
              };
            }
            return { ...prevErrors, recipients: newRecipientErrors };
          });
          return updated;
        });
      }, 0);
    }

    // Hide Add Me after successful addition if signing order is disabled
    if (!signingOrder) {
      setAddMeVisible(false);
    }
    // Cache current user email for visibility rules
    setCurrentUserEmail(userEmail);
  }
  catch (err) {
    console.error('Add Me failed', err);
    showToaster('Failed to add current BoldSign user.', 'error');
  }
};
const removeRecipient = (id) => {
  if (recipients.length > 1) {
    const index = recipients.findIndex(r => r.id === id);
    // Remove the recipient
    const remainingRecipients = recipients.filter(recipient => recipient.id !== id);

    const normalizedRecipients = [...remainingRecipients]
      .sort((a, b) => a.order - b.order)
      .map((r, idx) => ({ ...r, order: idx + 1 }));

    setRecipients(normalizedRecipients);

    setErrors(prev => {
      const updatedErrors = [...prev.recipients];
      updatedErrors.splice(index, 1);

      return {
        ...prev,
        recipients: recomputeDuplicateErrors(
          normalizedRecipients,
          signingOrder,
          { recipients: updatedErrors }
        )
      };
    });

    // Remove corresponding color
    setRecipientColors(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  }
};

  useEffect(() => {
    setErrors(prev => ({
      ...prev,
      recipients: recomputeDuplicateErrors(recipients, signingOrder, prev)
    }));
  }, [recipients, signingOrder]);
  // Track whether a recipient field has been touched (blurred) to control when to show errors
  const [recipientTouched, setRecipientTouched] = useState({});

  const handleRecipientBlur = (id, field) => {
    setRecipientTouched(prev => ({
      ...prev,
      [id]: { ...(prev[id] || {}), [field]: true }
    }));

    // Trigger validation for this field after touch
    const index = recipients.findIndex(r => r.id === id);
    if (index !== -1) {
      setErrors(prev => {
        const newRecipientErrors = [...prev.recipients];
        if (!newRecipientErrors[index]) {
          newRecipientErrors[index] = { name: '', email: '', phone: '' };
        }

        if (field === 'email') {
          // Clear duplicate markers; they will be recalculated below
          for (let i = 0; i < newRecipientErrors.length; i++) {
            if (newRecipientErrors[i] && newRecipientErrors[i].email === 'Email already exists') {
              newRecipientErrors[i] = { ...newRecipientErrors[i], email: '' };
            }
          }

          const emailTrim = (recipients[index].email || '').trim();
          if (emailTrim === '') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Email is required' };
          } else if (!isValidEmail(emailTrim)) {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Please enter a valid email' };
          } else {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: '' };
          }

          // Duplicate check across all recipients
          const updatedRecipients = [...recipients];
          const emailsMap = new Map();
          const duplicateEmails = new Set();
          updatedRecipients.forEach((recipient, idx) => {
            const email = (recipient.email || '').trim().toLowerCase();
            if (email && isValidEmail(email)) {
              if (emailsMap.has(email)) duplicateEmails.add(email);
              else emailsMap.set(email, idx);
            }
          });
          updatedRecipients.forEach((recipient, idx) => {
            const email = (recipient.email || '').trim().toLowerCase();
            if (!signingOrder && email && duplicateEmails.has(email)) {
              if (!newRecipientErrors[idx]) newRecipientErrors[idx] = { name: '', email: '' };
              newRecipientErrors[idx] = { ...newRecipientErrors[idx], email: 'Email already exists' };
            }
          });

          // Also check against CC emails
          const emailLower = (recipients[index].email || '').trim().toLowerCase();
          if (emailLower && ccEmailTags.map(e => e.toLowerCase()).includes(emailLower)) {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Recipient already exists in CC' };
          }
        } else if (field === 'name') {
          const nameTrim = (recipients[index].name || '').trim();
          if (nameTrim === '') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], name: 'Name is required' };
          } else if (newRecipientErrors[index].name === 'Name is required') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], name: '' };
          }
        } else if (field === 'phone') {
          const currentPhone = validate.normalizePhoneNumber(recipients[index].phone);          
          if (!currentPhone) {
              newRecipientErrors[index] = {
                ...newRecipientErrors[index],
                phone: 'Phone number is required'
              };
            } else {
              const isDuplicate = recipients.some((r, i) =>
                i !== index &&
                validate.normalizePhoneNumber(r.phone) === currentPhone
              );
              if (isDuplicate) {
                newRecipientErrors[index] = {
                  ...newRecipientErrors[index],
                  phone: 'Recipient already exists'
                };
              } else {
                newRecipientErrors[index] = {
                  ...newRecipientErrors[index],
                  phone: ''
                };
              }
            }
        }

        return { ...prev, recipients: newRecipientErrors };
      });
    }
  };

  const updateRecipientPhone = (id, iso, countryCode, phone, fullPhone) => {

    setRecipients(prev =>
      prev.map(r =>
        r.id === id
          ? {
            ...r,
            iso: iso,
            countryCode: countryCode,
            phone: phone || '',
            fullPhone: phone ? fullPhone : (countryCode || '')
          }
          : r
      )
    );

    setErrors(prev => {
      const newRecipientErrors = [...prev.recipients];
      const index = recipients.findIndex(r => r.id === id);
      if (index === -1) return prev;

      if (!newRecipientErrors[index]) {
        newRecipientErrors[index] = { phone: '' };
      }

      const currentPhone = validate.normalizePhoneNumber(phone);

      if (!currentPhone) {
        newRecipientErrors[index].phone = 'Phone number is required';
        return { ...prev, recipients: newRecipientErrors };
      }

      if (!validate.isValidPhoneNumber(countryCode + phone)) {
        newRecipientErrors[index].phone = 'Please enter a valid phone number';
        return { ...prev, recipients: newRecipientErrors };
      }

      const isDuplicate = recipients.some(
        (r) =>
          r.id !== id &&
          r.countryCode === countryCode &&
          validate.normalizePhoneNumber(r.phone) === currentPhone
      );

      if (!signingOrder && isDuplicate) {
        newRecipientErrors[index].phone = 'Recipient already exists';
        return { ...prev, recipients: newRecipientErrors };
      }

      newRecipientErrors[index].phone = '';
      return { ...prev, recipients: newRecipientErrors };
    });
  };
  useEffect(() => {
    const showBrands = async () => {
      try {
        const response = await api.get('/boldsign/get-brand-details');
        if (response.status === 200) {
          const data = await response.data;
          // Normalize shape so the dropdown keys/labels are stable regardless of SDK casing
          const normalized = Array.isArray(data)
            ? data.map(b => ({
                id: b.brandId,
                brandName: b.brandName,
                isDefault: b.isDefault
              }))
            : [];
          setBrandsList(normalized);
          setIsBrandsListEmpty(normalized.length === 0);
        }
      }
      catch (error) {
        console.error('Failed to load brands.', error);
        setIsBrandsListEmpty(true);
      }
    }
    showBrands();
  }, []);

  const handleDeliveryOptionChange = (recipientId, option) => {
    setRecipients(prev =>
      prev.map(r => {
        if (r.id !== recipientId) return r;

        let updated = {
          ...r,
          deliveryOption: option
        };

        // Determine whether the currently selected authType is still valid
        // for the new delivery option. If not, disable authentication and
        // reset to the default ('accessCode').
        const isEmailOtp = (r.authType || '').toLowerCase() === 'email';
        const isSmsOtp = (r.authType || '').toLowerCase() === 'sms';

        let showAuthenticationSetting = r.showAuthenticationSetting;
        let authType = r.authType;
        if (option === 'SMS') {
          // Email OTP requires Email or EmailAndSMS delivery
          if (isEmailOtp) {
            showAuthenticationSetting = false;
            authType = 'accessCode';
          }
        } else if (option === 'Email') {
          // SMS OTP requires SMS or EmailAndSMS delivery
          if (isSmsOtp) {
            showAuthenticationSetting = false;
            authType = 'accessCode';
          }
        }
        // For 'EmailAndSMS' both Email OTP and SMS OTP remain valid, so
        // existing showAuthenticationSetting/authType are kept as-is.

        updated.showAuthenticationSetting = showAuthenticationSetting;
        updated.authType = authType;

        if (option === 'SMS' || option === 'EmailAndSMS') {
          if (!r.iso) {
            updated.iso = DEFAULT_COUNTRY;
            updated.countryCode = '+1';
            updated.fullPhone = '';
            updated.phone = '';
          }
          if (option === 'SMS') {
            updated.email = '';
          }
        }
        if (option === 'Email') {
          updated.phone = '';
          updated.fullPhone = '';
          updated.countryCode = '';

          setErrors(prev => {
            const updatedErrors = [...prev.recipients];
            const idx = recipients.findIndex(r => r.id === recipientId);

            if (idx !== -1 && updatedErrors[idx]) {
              updatedErrors[idx].phone = '';
            }

            return { ...prev, recipients: updatedErrors };
          });
        }

        return updated;
      })
    );
    setErrors(prev => {
      const idx = recipients.findIndex(r => r.id === recipientId);
      if (idx === -1) return prev;

      const updatedErrors = [...prev.recipients];
      if (!updatedErrors[idx]) updatedErrors[idx] = {};

      if (option === 'SMS') {
        updatedErrors[idx].email = '';
      }

      if (option === 'Email') {
        updatedErrors[idx].phone = '';
      }

      return { ...prev, recipients: updatedErrors };
    });
  };

  const updateRecipient = (id, field, value) => {
    const index = recipients.findIndex(r => r.id === id);
    
    // Create updated recipients list
    const updatedRecipients = recipients.map(recipient =>
      recipient.id === id ? { ...recipient, [field]: value } : recipient
    );
    
    if (field === 'role' && value === 'reviewer') {
        updatedRecipients.allowFieldConfigurationSetting = false;
    }

    // Update the recipients state
    setRecipients(updatedRecipients);
    
    // If updating the email field, and it already exists in CC, show inline error (do not remove from CC)
    if (field === 'email' && value.trim() && isValidEmail(value.trim())) {
      const emailToCheck = value.trim().toLowerCase();
      const emailExistsInCC = ccEmailTags.some(ccEmail => ccEmail.toLowerCase() === emailToCheck);

      if (emailExistsInCC) {
        setErrors(prev => {
          const newRecipientErrors = [...prev.recipients];
          if (!newRecipientErrors[index]) {
            newRecipientErrors[index] = { name: '', email: '' };
          }
          newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Recipient already exists in CC' };
          return { ...prev, recipients: newRecipientErrors };
        });
      }
    }

    // If updating the name field, filter contact suggestions
    if (field === 'name') {
      filterContactSuggestions(value);
    }
    
    // Validate on blur or after field has been touched; avoid showing errors while typing initially
    if (index !== -1) {
      setErrors(prev => {
        if (!recipientTouched[id]?.[field]) {
          return prev;
        }

        const newRecipientErrors = [...prev.recipients];
        if (!newRecipientErrors[index]) {
          newRecipientErrors[index] = { name: '', email: '' };
        }

        if (field === 'email') {
          for (let i = 0; i < newRecipientErrors.length; i++) {
            if (newRecipientErrors[i] && newRecipientErrors[i].email === 'Email already exists') {
              newRecipientErrors[i] = { ...newRecipientErrors[i], email: '' };
            }
          }

          const emailTrim = (value || '').trim();
          if (emailTrim === '') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Email is required' };
          } else if (!isValidEmail(emailTrim)) {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: 'Please enter a valid email' };
          } else {
            newRecipientErrors[index] = { ...newRecipientErrors[index], email: '' };
          }

          const emailsMap = new Map();
          const duplicateEmails = new Set();
          updatedRecipients.forEach((recipient, idx) => {
            const email = recipient.email.trim().toLowerCase();
            if (email && isValidEmail(email)) {
              if (emailsMap.has(email)) duplicateEmails.add(email);
              else emailsMap.set(email, idx);
            }
          });
          updatedRecipients.forEach((recipient, idx) => {
            const email = recipient.email.trim().toLowerCase();
            if (!signingOrder && email && duplicateEmails.has(email)) {
              if (!newRecipientErrors[idx]) newRecipientErrors[idx] = { name: '', email: '' };
              newRecipientErrors[idx] = { ...newRecipientErrors[idx], email: 'Email already exists' };
            }
          });
        } else if (field === 'name') {
          if (value.trim() === '') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], name: 'Name is required' };
          } else if (newRecipientErrors[index].name === 'Name is required') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], name: '' };
          }
        } else if (field === 'accessCode') {
          if (value.trim() === '') {
            newRecipientErrors[index] = { ...newRecipientErrors[index], accessCode: 'Access code is required' };
          } else {
            newRecipientErrors[index] = { ...newRecipientErrors[index], accessCode: '' };
          }
        }

        return { ...prev, recipients: newRecipientErrors };
      });
    }
    
    setActiveDropdown({ type: null, id: null });
  };
  const startEditingOrder = useCallback((recipientId) => {
  const recipient = recipients.find(r => r.id === recipientId);
  if (recipient) {
    setEditingOrderId(recipientId);
    setTempOrderValue(recipient.order.toString());
  }
}, [recipients]);
  const handleOrderChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setTempOrderValue(value);
  };
  const handleOrderKeyPress = (e) => {
    if (e.key === 'Enter') {
      finishEditingOrder();
    }
  };
  // Get role icon by ID
  const getRoleIcon = (roleId) => {
    const role = recipientRoles.find(r => r.id === roleId);
    return role ? role.icon : <div className="signer-icon"></div>;
  };
  // Display-only conversion for language code: show hyphen in UI, keep underscore in value
  const getDisplayLanguageCode = (code) => {
    if (!code) return '';
    return code.replace('_', '-');
  };
  const isValidEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };
  const validateCcEmails = (emails) => {
    if (!emails.trim()) return true;
    
    const emailList = emails.split(',').map(e => e.trim());
    return emailList.every(email => isValidEmail(email));
  };
  // Toggle delivery options visibility based on checkbox
  const toggleOption = (recipientId, type) => {
    setRecipients(prev =>
      prev.map(r => {
        if (r.id !== recipientId) return r;

        if (type === "delivery") {
          return {
            ...r,
            showDeliveryOptions: !r.showDeliveryOptions,
            showSettingsOptions: false
          };
        }

        if (type === "settings") {
          return {
            ...r,
            showSettingsOptions: !r.showSettingsOptions,
            showDeliveryOptions: false
          };
        }

        return r;
      })
    );
  };
  
  const toggleSetting = (id, key) => {
    const index = recipients.findIndex(r => r.id === id);
    const recipient = recipients.find(r => r.id === id);
    if (key === "allowFieldConfigurationSetting" && recipient?.role === "reviewer") {
        return;
      }

    setRecipients(prev =>
      prev.map(r =>
        r.id === id
          ? { ...r, [key]: !r[key] }
          : r
      )
    );
    setErrors(prev => {
      const newRecipientErrors = [...prev.recipients];
      if (newRecipientErrors[index]) {
        newRecipientErrors[index] = { accessCode: '', phone: '' };
      }
      return { ...prev, recipients: newRecipientErrors };
    });
  };
  
  const handleAuthTypeChange = (id, value) => {
    setRecipients(prev =>
      prev.map(r =>
        r.id === id
          ? { ...r, authType: value }
          : r
      )
    );
  };

  const authTypeToShow = (recipient) => {
    if (recipient.authType === 'accessCode') {
      if (!recipient.accessCode) {
        return {
          text: 'Access code enabled but value not filled',
          isError: true
        };
      }
      return {
        text: 'Access Code',
        isError: false
      };
    }

    if (recipient.authType === 'email') {
      return {
        text: 'Email OTP',
        isError: false
      };
    }

    if (recipient.authType === 'SMS') {
      if (!recipient.phone && recipient.deliveryOption === 'Email') {
        return {
          text: 'Please enter a valid phone number',
          isError: true
        };
      }
      return {
        text: 'SMS OTP',
        isError: false
      };
    }

    return { text: '', isError: false };
  };

  const validateForm = () => {
    // We'll update existing errors but preserve any existing recipient errors
    const currentErrors = { ...errors };
    let isValid = true;

    // Validate files
    const totalFiles = uploadedFiles.length + uploadingFiles.length;
    if (totalFiles === 0) {
      currentErrors.files = 'At least one document is required';
      isValid = false;
    } else {
      currentErrors.files = '';
    }

    const uniqueLocalesValidate = getUniqueRecipientLocales();
    if (uniqueLocalesValidate.length > 1) {
      const missing = uniqueLocalesValidate
        .filter((loc) => !((documentInfo[loc] && documentInfo[loc].title) || '').trim())
        .map((loc) => `${languageNames[loc] || loc}`);
      if (missing.length > 0) {
        currentErrors.title = `Document title is required for: ${missing.join(', ')}`;
        isValid = false;
      } else {
        currentErrors.title = '';
      }
    } else if (!documents.title.trim()) {
      currentErrors.title = 'Document title is required';
      isValid = false;
    } else {
      currentErrors.title = '';
    }

    // Validate CC field
    if (ccInputValue && !isValidEmail(ccInputValue.trim())) {
      currentErrors.cc = 'Please enter a valid email address';
      isValid = false;
    } else {
      currentErrors.cc = '';
    }

    // For recipients, do a complete validation
    const recipientErrors = recipients.map(() => ({
      name: '', email: '', phone: '' 
    }));

    recipients.forEach((recipient, index) => {
      const fullPhone = (recipient.countryCode || '') + (recipient.phone || '');
      const normalizedPhone = fullPhone.replace(/\D/g, '');

      if (!recipient.name.trim()) {
        recipientErrors[index].name = 'Name is required';
        isValid = false;
      }

      if ((recipient.deliveryOption !== 'SMS') && (!recipient.email.trim() || !isValidEmail(recipient.email))) {
        recipientErrors[index].email = !recipient.email ? 'Email is required' : 'Please enter a valid email';
        isValid = false;
      }
      if (recipient.showAuthenticationSetting && recipient.authType === 'SMS' && !recipient.phone) {
        recipientErrors[index].phone = !recipient.phone ? 'Phone number is required' : 'Please enter a valid phone number'
        isValid = false;
      }
      if (recipient.showAuthenticationSetting && recipient.authType === 'accessCode' && !recipient.accessCode) {
        recipientErrors[index].accessCode = 'Access code is required';
        isValid = false;
      }
      if (recipient.deliveryOption !== 'Email') {
        if (!recipient.phone) {
          recipientErrors[index].phone = 'Phone number is required';
          isValid = false;
        } else if (!validate.isValidPhoneNumber(fullPhone)) {
          recipientErrors[index].phone = 'Please enter a valid phone number';
          isValid = false;
        }
      } else {
        recipientErrors[index].phone = '';
      }
    });

    // Duplicate emails (block ONLY when signing order is OFF)
    if (!signingOrder) {
      const emailsCount = new Map();
      const duplicateEmails = new Set();
      
      const phoneCount = new Map();
      const duplicatePhones = new Set();

      recipients.forEach(recipient => {
        const email = recipient.email.trim().toLowerCase();
        if (email && isValidEmail(email)) {
          emailsCount.set(email, (emailsCount.get(email) || 0) + 1);
          if (emailsCount.get(email) > 1) duplicateEmails.add(email);
        }
        
        const fullPhone = (recipient.countryCode || '') + (recipient.phone || '');
        const normalizedPhone = validate.normalizePhoneNumber(fullPhone);

        if (normalizedPhone && recipient.deliveryOption !== 'Email' && validate.isValidPhoneNumber(fullPhone)) {
          phoneCount.set(normalizedPhone, (phoneCount.get(normalizedPhone) || 0) + 1);
          if (phoneCount.get(normalizedPhone) > 1) duplicatePhones.add(normalizedPhone);
        }
      });

      if (duplicateEmails.size > 0 || duplicatePhones.size > 0) {
        isValid = false;
        recipients.forEach((recipient, index) => {
          const email = recipient.email.trim().toLowerCase();
          if (email && duplicateEmails.has(email)) {
            recipientErrors[index].email = 'Email already exists';
          }
          
          const fullPhone = (recipient.countryCode || '') + (recipient.phone || '');
          const normalizedPhone = validate.normalizePhoneNumber(fullPhone);

          if (normalizedPhone && recipient.deliveryOption !=='Email' && duplicatePhones.has(normalizedPhone)) {
            recipientErrors[index].phone = 'Recipient already exists';
          }
        });
      }
    }

    // Ensure at least one signer exists
    if (!recipients.some(r => r.role === 'signer')) {
      currentErrors.signerError = 'You need to assign atleast one signer for a document';
      isValid = false;
    } else {
      currentErrors.signerError = '';
    }

    // Validate reminder settings
    if (documentSettings.enableAutoReminder && documentSettings.expiryValue >= 2 && documentSettings.reminderDays > documentSettings.expiryValue) {
      // Validation is done internally in DocumentSettingsSection component
      // Just check if reminder error exists in documentSettings error state
      isValid = false;
    } else {
      currentErrors.reminder = '';
    }

    setErrors({
      ...currentErrors,
      recipients: recipientErrors
    });

    return isValid;
  };

  // Handle document settings changes from DocumentSettingsSection component
  const handleSettingsChange = (changedSettings) => {
    setDocumentSettings(prev => ({
      ...prev,
      ...changedSettings
    }));
  };

  const submitForm = async () => {
    setIsLoading(true);

    try {
      // Prepare FormData to send to the API
      const formData = new FormData();

      // Add every uploaded file in the exact order shown in the UI.
      // HubSpot attachments are converted to File objects before submission.
      for (let i = 0; i < uploadedFiles.length; i++) {
        const fileObj = uploadedFiles[i];
        if (fileObj.file) {
          formData.append('files', fileObj.file, fileObj.name);
        }
      }
      // First, collect all unique locales from recipients
      const uniqueLocales = [...new Set(recipients.map(recipient => recipient.locale || recipient.language))];
      const firstLocale = uniqueLocales[0]
      const info = documentInfo[firstLocale]
      // Add document metadata
      formData.append('title', info.title);
      // Only append message if it's not empty

      // Process CC recipients - send as individual ccEmails entries
      if (ccEmailTags.length > 0) {
        ccEmailTags.forEach((email) => {
          formData.append('ccEmails', email);
        });
      }

      formData.append('enableSigningOrder', signingOrder ? 'true' : 'false');
      // Check this in your browser's console
      formData.append('redirectUrl', window.location.origin + (popup ? '/documentSuccess?popup=1' : '/documentSuccess'));
      // Add recipients
      recipients.forEach((recipient, index) => {
        formData.append(`signers[${index}].name`, recipient.name);
        formData.append(`signers[${index}].locale`, recipient.language);
        formData.append(`signers[${index}].signerType`, recipient.role);
        if (signingOrder) {
          formData.append(`signers[${index}].signerOrder`, recipient.order);
        }

        // Delivery Mode
        formData.append(`signers[${index}].deliveryMode`,recipient.deliveryOption);

        // Send email or SMS or EmailAndSMS respective to deliveryOption.
        if (recipient.deliveryOption === 'Email') {
          formData.append(`signers[${index}].emailAddress`, recipient.email);
        } else if (recipient.deliveryOption === 'SMS') {
          formData.append(`signers[${index}].phoneNumber.number`, recipient.phone);
          formData.append(`signers[${index}].phoneNumber.countryCode`, recipient.countryCode);
        } else {
          formData.append(`signers[${index}].emailAddress`, recipient.email);
          formData.append(`signers[${index}].phoneNumber.number`, recipient.phone);
          formData.append(`signers[${index}].phoneNumber.countryCode`, recipient.countryCode);
        }
        if (recipient.showAuthenticationSetting) {
          if (recipient.authType === 'SMS') {
            formData.append(`signers[${index}].authenticationType`, 'SMSOTP');
            if (recipient.deliveryOption === 'Email') {
              formData.append(`signers[${index}].phoneNumber.number`, recipient.phone);
              formData.append(`signers[${index}].phoneNumber.countryCode`, recipient.countryCode);
            }
          }
          if (recipient.authType === 'email') {
            formData.append(`signers[${index}].authenticationType`, 'EmailOTP');
            formData.append(`signers[${index}].enableEmailOTP`, true);
          }
          if (recipient.authType === 'accessCode') {
            formData.append(`signers[${index}].authenticationType`, 'AccessCode');
            formData.append(`signers[${index}].authenticationCode`, recipient.accessCode);
          }
        }
        if (recipient.privateMessageSetting) {
          formData.append(`signers[${index}].privateMessage`, recipient.privateMessageSetting ? recipient.privateMessage : '');
        }
        if (recipient.allowFieldConfigurationSetting) {
          formData.append(`signers[${index}].allowFieldConfiguration`, recipient.role === 'reviewer' ? false : recipient.allowFieldConfigurationSetting);
        }
      });

      // Then create DocumentInfo entries for each unique locale
      uniqueLocales.forEach((locale, index) => {
        const info = documentInfo[locale] || { title: documents.title, message: documents.message };
        formData.append(`documentInfo[${index}].locale`, locale);
        formData.append(`documentInfo[${index}].title`, info.title || '');
        if (info.message && info.message.trim() !== '' && uniqueLocales.length > 1) {
          formData.append(`documentInfo[${index}].description`, info.message);
        }
      });

      formData.append('recordId', recordId);
      formData.append('objectType', objectType);

      // Send document settings from DocumentSettingsSection component
      if (documentSettings.brand && documentSettings.brand.id) {
        formData.append('brandId', documentSettings.brand.id);
      }

      formData.append('documentDownloadOption', documentSettings.documentDownloadOption);
      formData.append('enablePrintAndSign', documentSettings.enablePrintAndSign);
      formData.append('enableReassign', documentSettings.enableReassign);
      formData.append('disableExpiryAlert', !documentSettings.enableExpiryAlert);
      formData.append('labels', documentSettings.tags);
      formData.append('expiryDateType', 'Days');
      formData.append('expiryValue', parseInt(documentSettings.expiryValue));
      formData.append('reminderSettings.enableAutoReminder', documentSettings.enableAutoReminder);
      formData.append('reminderSettings.reminderDays', documentSettings.enableAutoReminder ? parseInt(documentSettings.reminderDays, 10) : '');
      formData.append('reminderSettings.reminderCount', documentSettings.enableAutoReminder ? parseInt(documentSettings.reminderCount, 10) : '');

      // Send to API
      const response = await api.post('/boldsign/send-document', formData);
      if (response.status !== 200) {
        const errorData = response?.data;
        if (errorData.error === 'BoldSignApiError') {
          showToaster(errorData.message, 'error');
        } else {
          setErrorPageConfig({
            title: errorContent.sendRequest.title,
            message: errorContent.sendRequest.message
          });
          setShowErrorPage(true);
        }
        return;
      }
      const documentUrl = await response.data;
      // Remove quotes from the documentUrl before setting iframe src
      const SendUrl = documentUrl.replace(/^["']|["']$/g, '');

      // Set the iframe URL from the response
      if (SendUrl) {
        setIframeSrc(SendUrl);
        setCurrentStep(2);
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Error processing documents:', error);
      setErrorPageConfig({
        title: errorContent.sendRequest.title,
        message: errorContent.sendRequest.message
      });
      setShowErrorPage(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNextButtonClick = async () => {
    if (isLoading) return;

    // First check if required URL parameters are available
    if (!recordId || !objectType) {
      showToaster("This page works only within HubSpot. If you're in HubSpot, try closing and reopening. Still not working? Reconnect or contact your admin.", 'error');
      return;
    }

    if (hasIncompleteUploads) {
        setErrors(prev => ({
          ...prev,
          progressError: 'Some of the uploaded file(s) are not completed.'
        }));
        return;
      }

    if (validateForm()) {
      // When more than one unique locale is present, prompt the user before
      // proceeding if any locale has an empty message.
      const missingLocales = getLocalesWithMissingMessage();
      if (missingLocales.length > 0) {
        setMissingMessageLocales(missingLocales);
        setShowLocaleMessageDialog(true);
        return;
      }

      await submitForm();
    }
  };  // Handle error page button click
  const closeLocaleMessageDialog = () => {
    setShowLocaleMessageDialog(false);
    setMissingMessageLocales([]);
  };
  const handleLocaleMessageDialogYes = async () => {
    setShowLocaleMessageDialog(false);
    setMissingMessageLocales([]);
    await submitForm();
  };

  const handleErrorPageButtonClick = () => {
    // Send DONE message to parent to close the modal/iframe
    try {
      window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
    } catch (error) {
      console.error("Error occurred when return to HubSpot:", error);
      // Fallback: try to go back in history
      if (window.history.length > 1) {
        window.history.back();
      }
    }
  };

  useEffect(() => {
    if (!hasIncompleteUploads && errors.progressError) {
      setErrors(prev => ({
        ...prev,
        progressError: ''
      }));
    }
  }, [hasIncompleteUploads, errors.progressError]);

  const recipientsForRender = signingOrder ? [...recipients].sort((a, b) => a.order - b.order) : [...recipients].sort((a, b) => a.order - b.order);

  // Show error page if needed
  if (showErrorPage) {
    return (
      <Error
        title={errorPageConfig.title}
        message={errorPageConfig.message}
        buttonText={errorPageConfig.buttonText}
        onButtonClick={handleErrorPageButtonClick}
      />
    );
  }

  return (
    <div className={styles.documentSendContainer}>
      {/* Toaster Component */}
      <Toaster
        show={toasterMessage.show}
        message={toasterMessage.message}
        type={toasterMessage.type}
        onClose={hideToaster}
        autoHide={true}
        autoHideDelay={3000}
      />

      {/* Locale message missing confirmation dialog */}
      <MissingLocaleMessageDialogBox
        show={showLocaleMessageDialog}
        localeCodes={missingMessageLocales}
        languageNames={languageNames}
        onClose={closeLocaleMessageDialog}
        onNo={closeLocaleMessageDialog}
        onYes={handleLocaleMessageDialogYes}
      />

      {currentStep === 1 && (
        <>
          <div className={styles.stepNavigationBar}>
            <div className={styles.stepIndicator}>
              Prepare document for signing<span className={styles.stepCount}>(Step 1/2)</span>
            </div>
            <button 
              className= "primary-button next-btn"
              onClick={handleNextButtonClick}
              disabled={isLoading}
            >Next
            </button>
            {isLoading && (
              <div className="loading-overlay">
                  <img src={loadIcon} alt="loading" className="spinner-circle-page"/>
              </div>
            )}
          </div>
          <div className={styles.documentContent}>
            <div className="contentSection">
              <FileUploadManager
                  mode="documentSend"
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  uploadingFiles={uploadingFiles}
                  setUploadingFiles={setUploadingFiles}
                  documents={documents}
                  setDocuments={setDocuments}
                  errors={errors}
                  setErrors={setErrors}
                  api={api}
                  popup={popup}
                  recordId={recordId}
                  objectType={objectType}
                  showToaster={showToaster}
              />
            </div>
            <div className="contentSection">
              <div className="contentBox">
              <div className="recipient-header">
                <div className="contentBoxHeader">Add Recipients</div>
                {<div className="signing-order-toggle">
                  {(addMeVisible || signingOrder) && (
                    <>
                    <button
                      className={styles.addMeLink}
                      onClick={handleAddMeClick}
                      aria-label="Add Me"
                    >
                      Add Me
                    </button>
                    <svg className={styles.separatorLine} viewBox="0 0 40 40" aria-hidden="true">
                      <line x1="20" y1="0" x2="20" y2="40" className={styles.line} />
                    </svg>
                    </>
                  )}
                  <label className="toggle-switch" aria-label="Signing Order">
                    <input
                      type="checkbox"
                      checked={signingOrder}
                      onChange={() => {
                        const newSigningOrder = !signingOrder;
                        setSigningOrder(newSigningOrder);

                        setErrors(prev => {
                          const newRecipientErrors = [...prev.recipients];

                          if (newSigningOrder) {
                            // CLEAR duplicate errors when signing order ON
                            newRecipientErrors.forEach((err, idx) => {
                              if (err?.email === 'Email already exists') {
                                newRecipientErrors[idx] = { ...err, email: '' };
                              }
                              if (err?.phone === 'Recipient already exists') {
                                newRecipientErrors[idx] = { ...err, phone: '' };
                              }
                            });
                          } else {
                            // RE-APPLY duplicate errors when signing order OFF
                            const mapEmail = new Map();
                            const mapPhone = new Map();
                            
                            recipients.forEach((r, idx) => {
                              const email = (r.email || '').trim().toLowerCase();

                              if (email && isValidEmail(email)) {
                                mapEmail.set(email, [...(mapEmail.get(email) || []), idx]);
                              }

                              if ( r.deliveryOption === 'SMS' || r.deliveryOption === 'EmailAndSMS' ) {
                                const normalized = validate.normalizePhoneNumber(r.phone);
                                const fullPhone = (r.countryCode || '') + (r.phone || '');
                                
                                if (normalized && validate.isValidPhoneNumber(fullPhone)) {
                                  mapPhone.set(normalized, [...(mapPhone.get(normalized) || []), idx]);
                                }
                              }
                            });
                            
                            mapEmail.forEach(indices => {
                              if (indices.length > 1) {
                                indices.forEach(i => {
                                  if (!newRecipientErrors[i]) newRecipientErrors[i] = {};
                                  newRecipientErrors[i].email = 'Email already exists';
                                });
                              }
                            });
                            
                            mapPhone.forEach(indices => {
                              if (indices.length > 1) {
                                indices.forEach(i => {
                                  if (!newRecipientErrors[i]) newRecipientErrors[i] = {};
                                  newRecipientErrors[i].phone = 'Recipient already exists';
                                });
                              }
                            });
                          }
                          return { ...prev, recipients: newRecipientErrors };
                        });
                      }}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                  <span>Signing Order</span>
                  <button className="help-button">
                    <span className = {`${styles.iconBase} ${styles.signingOrderinfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="so-tooltip"></span>
                  </button>
                  <Tooltip
                    id="so-tooltip"
                    place="top"
                    className='tooltip-info'
                    render={() => (
                      <div className="tooltip-content">
                        Enable this option to specify signing order for recipients.
                      </div>
                    )}
                  />
                </div>}
              </div>
              {errors.signerError && <div className="error-message">{errors.signerError}</div>}
              <div className="recipients-list">
                {recipientsForRender.map((recipient, index) => (
                  <div                   
                    key={recipient.id}
                    ref={el => recipientRowRefs.current[recipient.id] = el}
                    className={`recipient-data ${signingOrder ? 'so-enabled' : ''} ${dragOverId === recipient.id ? 'drag-over' : ''} ${draggingId === recipient.id ? 'dragging' : ''} ${hoveredRecipientId === recipient.id && recipient.role === 'signer' ? styles.recipientHoverHighlight : ''}`}
                    draggable={signingOrder}
                    onDragStart={(e) => onDragStartHandle(e, recipient.id)}
                    onDragEnd={onDragEndHandle}
                    onMouseEnter={() => setHoveredRecipientId(recipient.id)}
                    onMouseLeave={() => setHoveredRecipientId(null)}
                    onDragOver={(e) => onDragOverRow(e, recipient.id)}
                    onDrop={(e) => onDropRow(e, recipient.id)}
                    onDragEnter={() => setDragOverId(recipient.id)}
                    onDragLeave={() => setDragOverId(null)}
                  >
                    <div className={styles.recipientDataSoEnabled}>
                    {signingOrder && (
                      <div
                        className={styles.dragHandle}
                        draggable={true}
                        onDragStart={(e) => onDragStartHandle(e, recipient.id)}
                        onDragEnd={onDragEndHandle}
                        title="Drag to reorder"
                      >
                        <span className={`${styles.kebabIconLeft} sfIconBase sfKebabIcon`}></span>
                        <span className={`${styles.kebabIconRight} sfIconBase sfKebabIcon`}></span>
                      </div>
                    )}
                    <div className={styles.recipientFields}>           
                      <div
                        role="button"
                        tabIndex={0}
                        className={`recipient-number ${signingOrder ? 'editable' : ''}`}
                        onClick={() => signingOrder && startEditingOrder(recipient.id, index + 1)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            signingOrder && startEditingOrder(recipient.id, index + 1);
                          }
                        }}
                        style={{ backgroundColor: recipientColors[recipient.id] }}
                      >
                        {editingOrderId === recipient.id ? (
                          <input
                            ref={orderInputRef}
                            type="text"
                            value={tempOrderValue}
                            onChange={handleOrderChange}
                            onKeyDown={handleOrderKeyPress}
                            onBlur={finishEditingOrder}
                            className="order-input"
                          />
                        ) : (
                          recipient.order
                        )}
                      </div>
                      </div>
                      <div className={`recipient-name ${styles.floatingLabelWrapper}`} style={{ position: 'relative' }}>
                        {(focusedInputId === `name-${recipient.id}` || (recipient.name && recipient.name.trim() !== '')) && (
                          <span className={`${styles.floatingLabel} ${focusedInputId === `name-${recipient.id}` ? styles.floatingLabelActive : styles.floatingLabelStatic}`}>Recipient name*</span>
                        )}
                        <input
                          type="text"
                          placeholder={focusedInputId === `name-${recipient.id}` ? '' : 'Recipient name*'}
                          className={`recipient-input ${errors.recipients[index] && errors.recipients[index].name ? 'error' : ''}`}
                          value={recipient.name}
                          onChange={(e) => updateRecipient(recipient.id, 'name', e.target.value)}
                          onFocus={() => {
                            setFocusedInputId(`name-${recipient.id}`);
                            filterContactSuggestions(recipient.name);
                          }}
                          onBlur={() => { setFocusedInputId(null); handleRecipientBlur(recipient.id, 'name'); }}
                        />
                        {focusedInputId === `name-${recipient.id}` && filteredContactSuggestions.length > 0 && (
                          <div className="contact-suggestions-container">
                            {filteredContactSuggestions.map((contact, contactIndex) => (
                              <div 
                                key={contactIndex}
                                className="contact-suggestion-box" role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") applySuggestion(recipient.id, contact); }}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  applySuggestion(recipient.id, contact);
                                }}
                              >
                                <div className="contact-name">{contact.name}</div>
                                <div className="contact-email-phoneNumber">
                                  <span className="contact-email">
                                    {contact.email}
                                  </span>
                                    {contact.phoneNumberWithCountryCode !=='' && (<span className="contact-separator">|</span>)}
                                  <span className="contact-phone">
                                    {contact.phoneNumberWithCountryCode}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {errors.recipients[index] && errors.recipients[index].name && (
                          <span className="input-error">{errors.recipients[index].name}</span>
                        )}
                      </div>
                      {(recipient.deliveryOption  === 'Email' || recipient.deliveryOption === 'EmailAndSMS') && (
                        <div className={`recipient-email ${styles.floatingLabelWrapper}`}>
                        {(focusedInputId === `email-${recipient.id}` || (recipient.email && recipient.email.trim() !== '')) && (
                          <span className={`${styles.floatingLabel} ${focusedInputId === `email-${recipient.id}` ? styles.floatingLabelActive : styles.floatingLabelStatic}`}>Recipient email*</span>
                        )}
                        <input
                          type="email"
                          placeholder={focusedInputId === `email-${recipient.id}` ? '' : 'Recipient email*'}
                          className={`recipient-input ${errors.recipients[index] && errors.recipients[index].email ? 'error' : ''}`}
                          value={recipient.email}
                          onChange={(e) => updateRecipient(recipient.id, 'email', e.target.value)}
                          onFocus={() => setFocusedInputId(`email-${recipient.id}`)}
                          onBlur={() => { setFocusedInputId(null); handleRecipientBlur(recipient.id, 'email'); }}
                        />
                        {errors.recipients[index] && errors.recipients[index].email && (
                          <span className="input-error">{errors.recipients[index].email}</span>
                        )}
                        </div>
                      )}
                      {(recipient.deliveryOption === 'SMS' || recipient.deliveryOption === 'EmailAndSMS') && (
                        <InternationalPhoneInput
                          value={recipient.fullPhone}
                          iso={recipient.iso}
                          nationalNumber={recipient.phone}
                          error={errors.recipients[index]?.phone}
                          styles={styles}
                          showExample={recipient}
                          containerClassName={`recipient-phone`}
                          placeholderMode = 'ExampleNumber'
                          onChange={({ iso, countryCode, nationalNumber, fullPhone }) => {
                            updateRecipientPhone(
                              recipient.id,
                              iso,
                              countryCode,
                              nationalNumber,
                              fullPhone
                            );
                          }}
                          onFocus={() => setFocusedInputId(`phone-${recipient.id}`)}
                          onBlur={() => {
                            setFocusedInputId(null);
                            handleRecipientBlur(recipient.id, "phone");
                          }}
                        />
                      )}
                      {/* <div className={styles.recipientActions}> */}
                        {/* Role dropdown component */}
                        <div
                          className="custom-dropdown"
                          ref={el => dropdownRefs.current[`role-${recipient.id}`] = el}
                        >
                          <button
                            type="button"
                            className="dropdown-toggle-role"
                            onClick={() => toggleDropdown('role', recipient.id)}
                          >
                            <span className={`${styles.iconBase} role-icon`}>{getRoleIcon(recipient.role)}
                              <span className = {`${styles.roleDropDownIcon} sfIconBase sfDropDownIcon`}></span>
                            </span>
                            
                          </button>
                          {activeDropdown.type === 'role' && activeDropdown.id === recipient.id && (
                            <div className="dropdown-menu" style={{ display: 'block', position: 'absolute', zIndex: 1000 }}>
                              {recipientRoles.map(role => (
                                <div
                                  key={role.id}
                                  role="button"
                                  tabIndex={0}
                                  className={`dropdown-item ${recipient.role === role.id ? 'selected' : ''}`}
                                  onClick={() => updateRecipient(recipient.id, 'role', role.id)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      updateRecipient(recipient.id, 'role', role.id);
                                    }
                                  }}
                                >
                                  <span className="role-icon">{role.icon}</span>
                                  {role.name}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        {/* Language dropdown */}
                        <div
                          className="custom-dropdown"
                          ref={el => dropdownRefs.current[`language-${recipient.id}`] = el}
                        >
                          <button
                            type="button"
                            className="dropdown-toggle-language"
                            onClick={() => toggleDropdown('language', recipient.id)}
                          >
                            <span className="language-code">{getDisplayLanguageCode(recipient.language)}
                              <span className ={`${styles.languageDropDownIcon} sfIconBase sfDropDownIcon`}></span>
                            </span>
                            
                          </button>
                          
                          {activeDropdown.type === 'language' && activeDropdown.id === recipient.id && (
                            <div className="dropdown-menu" style={{ display: 'block', position: 'absolute', zIndex: 10, maxHeight: '200px', overflowY: 'auto', overflowX: 'hidden' }}>
                              {Object.entries(languageNames).map(([code, name]) => (
                                <div
                                  key={code}
                                  role="button"
                                  tabIndex={0}
                                  className={`dropdown-item ${recipient.language === code ? 'selected' : ''}`}
                                  onClick={() => updateRecipient(recipient.id, 'language', code)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      updateRecipient(recipient.id, 'language', code);
                                    }
                                  }}
                                >
                                  {name} <span className="language-code">({getDisplayLanguageCode(code)})</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        {recipients.length > 1 && (
                          <div className="delete">
                          <button
                            onClick={() => removeRecipient(recipient.id)}
                          >
                            <span className={`${styles.iconBase} ${styles.deleteIcon} sfIconBase sfDeleteIcon`}></span>
                          </button>
                          </div>
                        )}
                      </div>
                      {/* Delivery Options, Recipient Settings */}
                      <div className={styles.deliveryOptionButton} >
                        <label aria-label="Select Delivery Option">
                          <input
                            type="checkbox"
                            className={styles.deliveryOptionInput}
                            checked={recipient.showDeliveryOptions}
                            onChange={() => toggleOption(recipient.id, "delivery")}
                          />
                          <div className={styles.deliveryOption}>
                            <span className={`${styles.sfIconBase} ${styles.sfSendNowIcon}`} style={{ fontSize: "15px" }}></span>
                            <span className={styles.deliveryOptionText}>{recipient.deliveryOption === 'SMS'  ? 'SMS'  : recipient.deliveryOption === 'Email'  ? 'Email'  : 'Email & SMS'}</span>
                            <span className={recipient.showDeliveryOptions ? `${styles.sfIconBase} ${styles.sfWrapUp}` : `${styles.sfIconBase} ${styles.sfDropDown}`}></span>
                          </div>
                        </label>    
                        {/* Settings Option */}
                        <label aria-label="Settings">
                          <input
                            type ="checkbox"
                            className = {styles.settingsOptionInput}
                            checked = {recipient.showSettingsOptions}
                            onChange = {() => toggleOption(recipient.id, "settings")}
                          />
                          <div className={styles.deliveryOption}>
                            <span className={`${styles.sfIconBase} ${styles.sfGearIcon} sfIconBase sfGearIcon`} style={{ fontSize: "15px" }}></span>
                            <span className={styles.deliveryOptionText}>Settings</span>
                            <span className={recipient.showSettingsOptions  ? `${styles.sfIconBase} ${styles.sfWrapUp}`  : `${styles.sfIconBase} ${styles.sfDropDown}`}></span>
                          </div>
                        </label>
                        {!recipient.showSettingsOptions && recipient.showAuthenticationSetting && (() => {
                          const result = authTypeToShow(recipient);
                        
                          return (
                            <div className={styles.knowAuth}>
                              <span className={`${styles.sfIconBase} ${styles.sfTickIcon} ${result.isError ? styles.sfTickIconError : ''}  sfIconBase sfTickIcon`}></span>

                              <span className= {`${result.isError ? styles.authError : ''}`}>{result.text}</span>
                            </div>
                          );
                        })()}
                      </div>
                      {recipient.showDeliveryOptions && (
                        <div className={styles.deliveryOptionInfo}>
                          <div className={styles.TitleContainer}>
                            <span className={styles.deliveyOptionTitle}>Delivery Option </span>
                            <button className={styles.helpButton}>
                              <span className = {`${styles.iconBase} ${styles.deliveryOptionInfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="do-tooltip"></span>
                            </button>
                            <Tooltip
                              id="do-tooltip"
                              place="right"
                              className='tooltip-info tip-delivery-options'
                              clickable
                              render={() => (
                                <div className="tooltip-content">
                                  Choose a delivery mode for notifications. For more<br /> information, see <a href='https://support.boldsign.com/kb/article/13965/send-signature-requests-via-sms' target="_blank" rel="noopener noreferrer" className={styles.tooltipLink}>delivery options<span className={styles.sfIconOpenLink}></span></a>.
                                </div>
                              )}
                            />
                          </div>
                          <div className={styles.deliveryOptionsContainer}>
                            <label className={styles.deliveryOptions}>
                              <input
                                type="radio"
                                name={`deliveryOption-${recipient.id}`}
                                id={`emailDelivery-${recipient.id}`}
                                value="Email"
                                checked={recipient.deliveryOption === 'Email'}
                                onChange={() => handleDeliveryOptionChange(recipient.id, 'Email')}
                                className={styles.radioIcon}
                              />
                              <span className = {styles.availableDeliveyOptions}>Email</span>
                            </label>
                            <label className={styles.deliveryOptions}>
                              <input
                                type="radio"
                                name={`deliveryOption-${recipient.id}`}
                                id={`smsDelivery-${recipient.id}`}
                                value="SMS"
                                checked={recipient.deliveryOption === 'SMS'}
                                onChange={() => handleDeliveryOptionChange(recipient.id, 'SMS')}
                                className={styles.radioIcon}
                              />
                              <span className = {styles.availableDeliveyOptions}>SMS</span>
                            </label>
                            <label className={styles.deliveryOptions}>
                              <input
                                type="radio"
                                name={`deliveryOption-${recipient.id}`}
                                id={`smsDelivery-${recipient.id}`}
                                value="EmailAndSMS"
                                checked={recipient.deliveryOption === 'EmailAndSMS'}
                                onChange={() => handleDeliveryOptionChange(recipient.id, 'EmailAndSMS')}
                                className={styles.radioIcon}
                              />
                              <span className = {styles.availableDeliveyOptions}>Email & SMS</span>
                            </label>
                          </div>
                        </div>
                      )}
                      {recipient.showSettingsOptions && (
                        <div className={styles.deliveryOptionInfo}>
                          <div className={styles.settingsOptionsContainer}>
                            {/* Toggle 1 */}
                            <div className={styles.availableSettings}>
                              <label className={`${styles.toggleSwitch} toggle-switch`} aria-label="Settings Toggle">
                                <input
                                  type="checkbox"
                                  checked={recipient.showAuthenticationSetting}
                                  onChange={() => toggleSetting(recipient.id, "showAuthenticationSetting")}
                                />
                                <span className={`${styles.toggleSlider} toggle-slider`}></span>
                              </label>
                              <span className= {styles.settingsOption}>Authentication</span>
                              <button className="help-button">
                                <span className = {`${styles.iconBase} ${styles.authenticationinfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="auth-tooltip"></span>
                              </button>
                              <Tooltip
                                id="auth-tooltip"
                                place="top"
                                className='tooltip-authInfo'
                                render={() => (
                                  <div className="tooltip-content">
                                    Recipients will be required to enter a system-generated one-time password or a sender-specified access code to view and sign the document.
                                  </div>
                                )}
                              />
                            </div>
                            {/* CHILD OPTIONS */}
                              {recipient.showAuthenticationSetting && (
                                <div className={styles.settingsChildren}>
                                  <label className={styles.radioOption}>
                                    <input 
                                      type = "radio"
                                      name = {`auth-${recipient.id}`}
                                      checked = {recipient.authType === 'email' && recipient.deliveryOption !== 'SMS'}
                                      onChange={() => handleAuthTypeChange(recipient.id, "email")}
                                      className = {styles.radioIcon}
                                      disabled = {recipient.deliveryOption === 'SMS'}
                                      />
                                    <span className={recipient.deliveryOption === 'SMS' ? styles.disableEmailOTP : ''}>Email OTP (One Time Password)</span>
                                  </label>
                              
                                  <label className={styles.radioOption}>
                                    <input
                                      type="radio"
                                      name = {`auth-${recipient.id}`}
                                      checked = {recipient.authType === 'SMS'}
                                      onChange={() => handleAuthTypeChange(recipient.id, "SMS")}
                                      className={styles.radioIcon}
                                    />
                                    <span>SMS OTP</span>
                                  </label>
                                  {recipient.authType === "SMS" && (recipient.deliveryOption === 'Email') && (
                                    <div className={styles.SMSSection}>
                                      {/* Phone Input */}
                                      <InternationalPhoneInput
                                        value={recipient.fullPhone}
                                        containerClassName={`recipient-phone`}
                                        iso={recipient.iso}
                                        nationalNumber={recipient.phone}
                                        error={errors.recipients[index]?.phone}
                                        showExample={recipient}
                                        styles={styles}
                                        onChange={({ iso, countryCode, nationalNumber, fullPhone }) => {
                                          updateRecipientPhone(
                                            recipient.id,
                                            iso,
                                            countryCode,
                                            nationalNumber,
                                            fullPhone
                                          );
                                        }}
                                        onFocus={() => setFocusedInputId(`phone-${recipient.id}`)}
                                        onBlur={() => {
                                          setFocusedInputId(null);
                                          handleRecipientBlur(recipient.id, "phone");
                                        }}
                                        placeholderMode = 'ExampleNumber'
                                      />
                                      {/* Note text */}
                                      <div className={styles.smsNote}>
                                        Note: OTP will be sent to the recipient via SMS. A fee will be charged per SMS sent.
                                      </div>
                                    </div>
                                  )}
                                  <label className={styles.radioOption}>
                                    <input
                                      type="radio"
                                      name = {`auth-${recipient.id}`}
                                      checked = {recipient.authType === 'accessCode'}
                                      onChange={() => handleAuthTypeChange(recipient.id, "accessCode")}
                                      className={styles.radioIcon}
                                    />
                                    <span>Access code</span>
                                  </label>
                                  <div className={styles.codeSection}>
                                    {recipient.authType === 'accessCode' && (
                                      <div>
                                        <div className={`recipient-accessCode ${styles.floatingLabelWrapper}`} style={{ position: 'relative', width: '100%' }}>
                                          {(focusedInputId === `accessCode-${recipient.id}` || (recipient.accessCode && recipient.accessCode.trim() !== '')) && (
                                            <span className={`${styles.floatingLabel} ${focusedInputId === `accessCode-${recipient.id}` ? styles.floatingLabelActive : styles.floatingLabelStatic}`}>Access code*</span>
                                          )}
                                          <input
                                            type="text"
                                            placeholder={focusedInputId === `accessCode-${recipient.id}` ? '' : 'Access code*'}
                                            className={`recipient-input ${errors.recipients[index] && errors.recipients[index].accessCode ? 'error' : ''}`}
                                            style={{width: '90%'}}
                                            value={recipient.accessCode}
                                            onChange={(e) => updateRecipient(recipient.id, 'accessCode', e.target.value)}
                                            onFocus={() => {
                                              setFocusedInputId(`accessCode-${recipient.id}`);
                                            }}
                                            onBlur={() => { setFocusedInputId(null); handleRecipientBlur(recipient.id, 'accessCode'); }}
                                          />
                                          {errors.recipients[index] && errors.recipients[index].accessCode && (
                                            <span className="input-error">{errors.recipients[index].accessCode}</span>
                                          )}
                                        </div>
                                        {/* Note text */}
                                        <div className={styles.smsNote}>
                                          Note: You must communicate this access code to the recipient directly.
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            {/* Toggle 2 */}
                            <div className={styles.availableSettings}>
                              <label className={`${styles.toggleSwitch} toggle-switch`} aria-label="Settings Toggle">
                                <input
                                  type="checkbox"
                                  checked={recipient.privateMessageSetting}
                                  onChange={() => toggleSetting(recipient.id, "privateMessageSetting")}
                                />
                                <span className={`${styles.toggleSlider} toggle-slider`}></span>
                              </label>
                              <span className= {styles.settingsOption}>Private Message</span>
                            </div>
                            {/* CHILD OPTIONS */}
                              {recipient.privateMessageSetting && (
                                <div className={styles.settingsChildren}>
                                  <textarea name="privateMessage" id="" className= {`${styles.privateMessage}`} placeholder='Enter any message that you would like to send to this recipient only.' onChange={(e) => updateRecipient(recipient.id,'privateMessage',e.target.value)}></textarea>
                                </div>
                              )}
                            {/* Toggle 3 */}
                            <div className={`${styles.availableSettings} ${recipient.role === 'reviewer' ? styles.toggleSwitchDisabled : ''}`}>
                              <label className={`${styles.toggleSwitch} toggle-switch`} aria-label="Settings Toggle">
                                <input
                                  type="checkbox"
                                  checked={recipient.role === 'reviewer' ? false : recipient.allowFieldConfigurationSetting}
                                  disabled={recipient.role === 'reviewer'}
                                  onChange={() => toggleSetting(recipient.id, "allowFieldConfigurationSetting")}
                                />
                                <span className={`${styles.toggleSlider} ${recipient.role === 'reviewer' ? styles.fieldConfigurationToggleSliderDisabled : ''} ${recipient.role === 'reviewer' ? styles.toggleSwitchDisabled : ''} toggle-slider`}></span>
                              </label>
                              <span className= {styles.settingsOption}>Allow Field Configuration</span>
                              <button className={`${styles.fieldHelpButton} help-button`}>
                                <span className = {`${styles.iconBase} ${styles.fielConfigurationinfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="field-tooltip"></span>
                              </button>
                              <Tooltip
                                id="field-tooltip"
                                place="top"
                                className='tooltip-fieldInfo'
                                render={() => (
                                  <div className="tooltip-content">
                                    Enable this feature to allow signers to add the required fields by dragging and dropping them into the document during the signing process.
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {/* Delivery Options and Recipient settings End */}
                    </div>
                ))}
              </div>
              <button
                id="add-recipient-btn"
                className={styles.addRecipientButton}
                onClick={addRecipient}
                data-tooltip-id={recipients.length >= MAX_RECIPIENTS ? "max-recipient-tooltip" : undefined}
              >
                <span className = {`${styles.iconBase} ${styles.sfAddIcon} sfIconBase sfAddIcon`}></span> Add recipient
              </button>
              <Tooltip
                id="max-recipient-tooltip"
                place="top"
                className="tooltip-info"
                render={() => (
                  <div className="tooltip-content">
                    Maximum recipient count should be less than or equal to {MAX_RECIPIENTS}
                  </div>
                )}
              />
            </div>
            </div>
            <div className="contentSection">
            <AddCC
              recipients={recipients}
              errors={errors}
              setErrors={setErrors}
              showToaster={showToaster}
              contactSuggestions={contactSuggestions}
              enableSuggestions={true}
              onCcChange={handleCcChange}
            />
            </div>
            <div className="contentSection">
              <div className="contentBox">
              <div className="contentBoxHeader">Document</div>
              <div className="document-fields">
                {(() => {
                  const tabs = getUniqueRecipientLocales();
                  const only = tabs.length === 1 ? tabs[0] : null;
                  const displayedLocale = only || activeLocale;
                  const active = displayedLocale ? (documentInfo[displayedLocale] || { title: '', message: '' }) : documents;

                  return (
                    <>
                      {tabs.length > 1 && (
                        <div role="tablist" aria-label="Document title language" className={styles.tabList}>
                          {tabs.map((loc) => {
                            const isActive = loc === activeLocale;
                            return (
                              <button
                                key={loc}
                                type="button"
                                role="tab"
                                aria-selected={isActive}
                                onClick={() => setActiveLocale(loc)}
                                className={isActive ? `${styles.tabActive} ${styles.tab}` : styles.tab}
                              >
                                {languageNames[loc]}&nbsp;({loc})
                              </button>
                            );
                          })}
                        </div>
                      )}
                      <div className="field-group">
                        <label htmlFor="document-title" className={styles.titleLabel}>
                          <span>Title</span>
                          <span className = {`${styles.iconBase} ${styles.titleInfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="title-tooltip"></span>
                        </label>
                        <Tooltip
                          id="title-tooltip"
                          place="right"
                          className='tooltip-info tip-title'
                          render={() => (
                            <div className="tooltip-content">
                              This is the document name that will be shown within the BoldSign user interface and also in the signature request email.
                            </div>
                          )}
                        />
                        <input
                          id="document-title"
                          type="text"
                          placeholder="Enter document title*"
                          className={`document-input ${errors.title ? 'error' : ''}`}
                          value={active.title || ''}
                          onChange={(e) => updateDocumentInfoField(displayedLocale, 'title', e.target.value, active)}
                        />
                        {errors.title && <div className="error-message">{errors.title}</div>}
                      </div>
                      <div className="field-group">
                        <label htmlFor="document-message">Message</label>
                        <textarea
                          id="document-message"
                          placeholder="Enter message for all recipients"
                          className="document-textarea"
                          value={active.message || ''}
                          onChange={(e) => updateDocumentInfoField(displayedLocale, 'message', e.target.value, active)}
                        />
                      </div>
                    </>
                  );
                })()}
              </div>
              </div>
            </div>
              <DocumentSettingsSection
                brandsList={brandslist}
                onSettingsChange={handleSettingsChange}
              />
          </div>
        </>
      )}
      {currentStep === 2 && (
        <div className={styles.iframeContainer}>
          <iframe 
            ref={iframeRef}
            src={iframeSrc} 
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="Document Preview"
          />
        </div>
      )}
    </div>
  );
};
export default DocumentSend;
